import React from "react";
import { withRouter } from "react-router";
import withStyles from "@material-ui/core/styles/withStyles";
import GetAppOutlinedIcon from "@material-ui/icons/GetAppOutlined";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Loader from "components/Loader/Loader.jsx";
import { API_GET, API_POST } from "../../services/api.service";
import { category, subCategory, productsList, status } from "./constants.js";
import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import { GetAppOutlined } from "@material-ui/icons";
import SupportFilter from "./SupportFilter";
import TabsComponent from "./components/tabs.jsx";
import SupportTable from "./components/table.jsx";
import SupportForm from "./components/supportForm.jsx";
import SupportReporting from "./components/SupportReporting";

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
};

const DEFAULT_DATA = (user) => ({
  category: null,
  product: "Betyphon",
  subCategory: null,
  comment: "",
  status: "Pending",
  adminComment: "",
  IsActive: true,
  createdOn: new Date(),
  updatedOn: null,
  updatedBy: null,
  admin: user.admin,
  user: user.username,
  userOption: null,
  externalQuery: false,
  company: user.company,
  plan: user.plan,
  scheduledTime: null,
});

class Support extends React.Component {
  constructor(props) {
    super(props);
    const { user } = this.props;

    this.state = {
      showLoader: true,
      editMode: false,
      allocatedUsers: [],
      editId: "",
      records: null,
      rowCount: 0,
      allUser: null,
      query: {},
      activeTab: 2,
      pendingCount: 0,
      resolvedCount: 0,
      roadmapCount: 0,
      monthlyTicketCount: 0,
      isResolved: true,
      ticketAssignedToOption: null,
      notify: {
        open: false,
        message: "",
        color: "success",
      },
      pop: false,
      rowsPerPage: 10,
      skip: 0,
      catoption: [],
      statusOption: status,
      subcatoption: [],
      productsList: productsList,
      notificationDetails: DEFAULT_DATA(user),
    };
  }

  componentDidMount() {
    this.initializeComponent();
  }

  initializeComponent = async () => {
    const { user } = this.props;
    const id = this.props.match.params.id;
    await this.getCategory();

    if (id) {
      this.setState({
        editMode: true,
        editId: id,
      });
      await this.editRecord(id);
    }

    this.setState({ showLoader: false });

    if (user) {
      if (user.admin === "mark@gmail.com" && user.role !== "owner") {
        await this.getRMAllocatedUsers(user.id);
      }

      await this.loadUsers(user);
      await this.loadTeam();

      const initialQuery = user.is_superuser
        ? { status: "Pending" }
        : { admin: user.admin };
      this.setState({
        query: initialQuery,
        activeTab: 2,
      });

      await this.loadRecords(user, initialQuery);
      await this.loadStats(user, initialQuery);
    }
  };

  getRMAllocatedUsers = async (userId) => {
    try {
      const userInfo = await API_GET(`register/allocatedUsers?id=${userId}`);
      if (userInfo.success) {
        const allocatedUsers = userInfo.data.map((v) => v.email);
        this.setState({
          allocatedUsers: allocatedUsers.length ? allocatedUsers : [],
        });
      }
    } catch (error) {
      console.error("Error fetching allocated users:", error);
    }
  };

  handleChangePage = async (newPage) => {
    const skip = (newPage - 1) * this.state.rowsPerPage;
    this.setState({ skip });
    await this.loadRecords(this.props.user, this.state.query);
    await this.loadStats(this.props.user, this.state.query);
    await this.loadUsers(this.props.user);
  };

  handleClose = () => {
    this.setState({ pop: false });
    this.props.history.push("/admin/support");
  };

  categoryChange = (e) => {
    const categoryValue = e.target.value;
    const subcat = subCategory[categoryValue] || [];
    const subcatoption = subcat.map((item) => ({
      key: item,
      value: item,
    }));

    this.setState((prevState) => ({
      notificationDetails: {
        ...prevState.notificationDetails,
        category: categoryValue,
        subCategory: null,
      },
      subcatoption,
    }));
  };

  filterUpdate = async (data) => {
    const { user } = this.props;
    let query = {};

    if (!user.is_superuser) {
      query = { admin: user.admin };
    }

    if (data.company)
      query.company = { $regex: "^" + data.company, $options: "i" };
    if (data.admin)
      query.$or = [
        { admin: { $regex: "^" + data.admin, $options: "i" } },
        { externalAdmin: { $regex: data.admin, $options: "i" } },
      ];
    if (data.category)
      query.category = { $regex: "^" + data.category, $options: "i" };
    if (data.subCategory)
      query.subCategory = { $regex: "^" + data.subCategory, $options: "i" };
    if (data.status)
      query.status = { $regex: "^" + data.status, $options: "i" };
    if (data.product)
      query.product = { $regex: "^" + data.product, $options: "i" };
    if (data.ticketAssignedTo)
      query.ticketAssignedTo = {
        $regex: "^" + data.ticketAssignedTo,
        $options: "i",
      };
    if (data.startDate) {
      query.createdOn = {
        $gte: new Date(data.startDate),
        $lt: new Date(data.endDate),
      };
    }

    this.setState({
      activeTab: 1,
      query,
    });
    await this.loadRecords(user, query);
  };

  loadTeam = async () => {
    try {
      const { user } = this.props;
      const userInfo = await API_GET(`register/GetAllMembersByUserId?id=8`);

      if (userInfo.success) {
        let list = userInfo.data.ActiveMembers.map((element) => ({
          key: element.username,
          value: `${element.username}--${element.first_name}`,
        }));

        if (user.is_superuser && user.role !== "owner") {
          list = list.filter(
            (v) => v.key === user.email || v.key === user.admin
          );
        }

        this.setState({ ticketAssignedToOption: list });
      }
    } catch (error) {
      console.error("Error loading team:", error);
    }
  };

  editRecord = async (id) => {
    try {
      const registerRequest = await API_POST("action/getdata", {
        root: "supportTickets",
        con: { _id: id },
      });

      if (registerRequest.data && registerRequest.data[0]) {
        const record = registerRequest.data[0];
        this.setState({ notificationDetails: record });
        this.categoryChange({ target: { value: record.category } });
      }
    } catch (error) {
      console.error("Error editing record:", error);
    }
  };

  getCategory = async () => {
    try {
      const registerRequest = await API_POST("action/getdata", {
        root: "supportCategories",
        con: {},
      });

      if (registerRequest.data && registerRequest.data[0]) {
        const record = registerRequest.data;
        console.log("record......", record);
        const category = record.map((v) => { return {key:v.categoryName,value:v.categoryName,visibleToRoles:v.visibleToRoles} }) ;
        const subCategoryIsPaid = [];
     
        record.forEach((v) => {
          console.log("v", v);
          v.subcategories.forEach((v) => {
            if(v.isPaid === true){
              subCategoryIsPaid.push(v.name);
            }
          });
        });
        
        this.setState({ catoption: category, paidSubCategory: subCategoryIsPaid });
        
      }
    } catch (error) {
      console.error("Error editing record:", error);
    }
  };

  loadStats = async (user, query = {}) => {
    try {
      if (this.state.allocatedUsers.length) {
        query.admin = { $in: this.state.allocatedUsers };
      }

      const registerRequeststats = await API_POST("action/getdata", {
        root: "supportTickets",
        con: query,
      });

      if (registerRequeststats.data) {
        const orderData = [...registerRequeststats.data].filter(v=> v.isDeleted !== true);
        const pendingCount = orderData.filter((v) => v.status === "Pending");
        const resolvedCount = orderData.filter((v) => v.status === "Resolved");
        const roadmapCount = orderData.filter((v) => v.status === "In Roadmap");
        const inProgress = orderData.filter(
          (v) => v.status === "In-Progress" || v.status === "Under Development"
        );
        const moveToDevelopmentCount = orderData.filter((v) => v.status === "Move to development");
        const todayQuery = orderData.filter((v) =>
          window.moment(v.createdOn).isSame(window.moment(), "day")
        );

        const lastMonthData = registerRequeststats.data.filter((v) =>
          (window.moment(v.createdOn).isSame(window.moment(), "month") && this.state.paidSubCategory.includes(v.subCategory) && !v.isDeleted)
        );        
        //console.log("lastMonthData", lastMonthData, (2 - lastMonthData.length));

        this.setState({
          totalCount: orderData,
          monthlyTicketCount: Math.max(2 - lastMonthData.length, 0),
          pendingCount,
          resolvedCount,
          roadmapCount,
          inProgressCount: inProgress,
          moveToDevelopmentCount,
          todayQuery,
        });
      }
    } catch (error) {
      console.error("Error loading stats:", error);
    }
  };

  loadRecords = async (user, query = {}) => {

    if (!user.admin) return;

    try {
     
      const body = {
        limit: this.state.rowsPerPage,
        skip: this.state.skip,
        sort: { _id: -1 },
      };

      console.log("body", body);
      if (this.state.allocatedUsers.length && user.username !='mark@gmail.com') {
        query.admin = { $in: this.state.allocatedUsers };
      }

      const registerRequest = await API_POST("action/getdata", {
        root: "supportTickets",
        con: {...query,$and: [{isDeleted: {$exists:false}}]},
        body,
      });



      if (registerRequest.data) {
        this.setState({
          records: [...registerRequest.data.data],
          rowCount: registerRequest.data.rowCount,
        });
      }
    } catch (error) {
      console.error("Error loading records:", error);
    }
  };

  loadUsers = async (user) => {
    try {
      if (user.admin) {
        const userInfoData = await API_GET(
          `register/GetProfileData?username=${user.admin}`
        );

        if (userInfoData.success && !this.state.editMode) {
          this.setState((prevState) => ({
            userPaidTicketCredits: userInfoData.data.ticketCredits,
            notificationDetails: {
              ...prevState.notificationDetails,
              phone: userInfoData.data.phone,
              company: userInfoData.data.company,
            },
          }));
        }
      }

      if (user.is_superuser) {
        const userInfo = await API_GET(
          `register/GetAllSubscriber?username=${user.admin}`
        );
        let opt = userInfo.data.map((item) => ({
          title: item.username,
          year: item.username,
          data: item,
        }));

        if (user.role !== "owner") {
          opt = opt.filter((v) => this.state.allocatedUsers.includes(v.title));
        }

        this.setState({ allUser: opt });
      }
    } catch (error) {
      console.error("Error loading users:", error);
    }
  };

  handletabs = async (event, newValue) => {
    const { user } = this.props;
    let query = {};

    console.log(typeof newValue);
    switch (newValue) {
      case "1":
        query = {};
        break;
      case "2":
        query = { status: "Pending" };
        break;
      case "3":
        query = { status: "Resolved" };
        break;
      case "4":
        query = { status: "In Roadmap" };
        break;
      case "5":
        query = { status: { $in: ["In-Progress"] } };
        break;
      case "6":
        query = { status: "Move to development" };
        break;
      case "7":
        query = { status: "Move to Administration" };
        break;  
      default:
        break;
    }

    console.log(query);
    this.setState({
      activeTab: newValue,
      query,
    });

    await this.loadRecords(user, query);
  };

  handleExportExcel = async () => {
    const { user } = this.props;

    try {
      const downloadFile = await API_POST(`action/ExportExcel`, {
        querydata: this.state.query,
        body: {
          admin: user.admin,
          user: user.username,
          page: "supportTickets",
        },
      });

      if (downloadFile.status === 200) {
        this.setState({
          notify: {
            open: true,
            message: "File is in process, Please check in system log section.",
            color: "success",
          },
        });
      }
    } catch (error) {
      console.error("Error exporting to Excel:", error);
    }
  };

  handleDelete = async (id) => {
    try {
      if(!id) return; 

      await API_POST("action/update",{
        root: "supportTickets",
        querydata: { _id: id },
        body: {
          isDeleted: true,
        },
      });
      this.setState({
        notify: {

          open: true,
          message: "Ticket deleted successfully.",
          color: "success",
        },
      });
      await this.loadRecords(this.props.user, this.state.query);
    } catch (error) {
      this.setState({
        notify: {
          open: true,
          message: "Failed to delete ticket.",
          color: "danger",
        },
      });
    }
  };

  renderStatsCard = (title, count) => (
    <GridItem xs={12} sm={2} md={2}>
      <Card>
        <CardBody>
          <h5>
            {title} <hr /> {count && Array.isArray(count) ? count.length : count || 0}
          </h5>
        </CardBody>
      </Card>
    </GridItem>
  );


  render() {
    const { classes, user } = this.props;
    const {
      records,
      notificationDetails,
      showLoader,
      pop,
      notify,
      activeTab,
      ticketAssignedToOption,
      rowsPerPage,
      rowCount,
      monthlyTicketCount,
      totalCount,
      pendingCount,
      resolvedCount,
      roadmapCount,
      inProgressCount,
      moveToDevelopmentCount,
      todayQuery,
      allUser,
      editId,
      editMode,
      userPaidTicketCredits,
    } = this.state;

    console.log("monthlyTicketCount", this.state);

    return (
      <>
        <Snackbar
          place="right"
          color={notify.color}
          message={notify.message}
          open={notify.open}
          closeNotification={() => this.setState({ notify: { open: false } })}
          close
        />

        <GridContainer>
         
          {this.renderStatsCard("Total Query", totalCount)}
          {this.renderStatsCard("Pending Query", pendingCount)}
          {this.renderStatsCard("Resolved Query", resolvedCount)}
          {this.renderStatsCard("In Progress Query", inProgressCount)}
          {this.renderStatsCard("Move to Development Query", moveToDevelopmentCount)}
          {this.renderStatsCard("Today Query", todayQuery)}
        </GridContainer>

        <br />
        {user.is_superuser ? <>  
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                  <SupportReporting totalCount={totalCount || []} />
              </Card>
            </GridItem>
        </GridContainer>
        
        </> : null  }


        {showLoader && <Loader />}
        {(user.is_superuser || user.role === "owner") && notificationDetails && editMode && this.props.match.params.id && (
          <Card>
            <SupportForm
              monthlyTicketCount = {monthlyTicketCount}
              paidTicketCredits = {userPaidTicketCredits}
              editId={editId}
              editMode={editMode}
              ticketAssignedToOption={ticketAssignedToOption}
              allUser={allUser}
              user={user}
              loadData={()=>this.handleChangePage(1)}
              setPop={(e) => this.setState({ pop: true })}
              notificationDetails={notificationDetails}
            />
          </Card>
        ) 
        }

        {
          (user.is_superuser || user.role === "owner") && notificationDetails && !editMode && !this.props.match.params.id && (
            <Card>
              <SupportForm
                monthlyTicketCount = {monthlyTicketCount}
                paidTicketCredits = {userPaidTicketCredits}
                editId={editId}
                editMode={editMode}
                ticketAssignedToOption={ticketAssignedToOption}
                allUser={allUser}
                user={user}
                loadData={()=>this.handleChangePage(1)}
                setPop={(e) => this.setState({ pop: true })}
                notificationDetails={notificationDetails}
              />
            </Card>
          )
        }



        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="white">
                <h3>Tickets List</h3>
              </CardHeader>

              <GridContainer>
                {user && (
                  <>
                    <GridItem xs={12} sm={12} md={12}>
                      <Button
                        style={{ float: "right" }}
                        size="sm"
                        color="primary"
                        justIcon
                        title="Export To Excel"
                        onClick={this.handleExportExcel}
                      >
                        <GetAppOutlined />
                      </Button>
                    </GridItem>

                    {ticketAssignedToOption && (
                      <SupportFilter
                        team={ticketAssignedToOption}
                        props={this.props}
                        onfilter={this.filterUpdate}
                        superUser={user.is_superuser}
                      />
                    )}
                  </>
                )}

                {user.is_superuser ? (
                  <TabsComponent
                    handletabs={this.handletabs}
                    tabStyle={tabStyle}
                    activeTab={activeTab}
                  />
                ): null}

                <GridItem xs={12} sm={12} md={12}>
                <SupportTable
                    ticketAssignedToOption={ticketAssignedToOption}
                    setPop={(e) => this.setState({ pop: true })}
                    user={user}
                    records={records}
                    handleChangePage={this.handleChangePage}
                    rowsPerPage={rowsPerPage}
                    rowCount={rowCount}
                    handleDelete={this.handleDelete}
                  />
                  
                  
                </GridItem>
              </GridContainer>
            </Card>
          </GridItem>
        </GridContainer>
      </>
    );
  }
}

const tabStyle = {
  textTransform: "none",
  fontSize: "18px",
  color: "white",
};

export default withStyles(styles)(Support);